/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PmRouteImport } from './routes/pm/route'
import { Route as IndexImport } from './routes/index'
import { Route as UtilitiesIndexImport } from './routes/utilities/index'
import { Route as TranslatorsIndexImport } from './routes/translators/index'
import { Route as TranslatorIndexImport } from './routes/translator/index'
import { Route as TranslationsIndexImport } from './routes/translations/index'
import { Route as SubscriptionIndexImport } from './routes/subscription/index'
import { Route as SignUpIndexImport } from './routes/sign-up/index'
import { Route as ReviewsIndexImport } from './routes/reviews/index'
import { Route as ResetPasswordIndexImport } from './routes/reset-password/index'
import { Route as ProjectsIndexImport } from './routes/projects/index'
import { Route as PmIndexImport } from './routes/pm/index'
import { Route as OrdersIndexImport } from './routes/orders/index'
import { Route as ClientsIndexImport } from './routes/clients/index'
import { Route as AssistantIndexImport } from './routes/assistant/index'
import { Route as AccountsIndexImport } from './routes/accounts/index'
import { Route as UtilitiesVerticalParallelIndexImport } from './routes/utilities/vertical-parallel/index'
import { Route as UtilitiesTextCounterIndexImport } from './routes/utilities/text-counter/index'
import { Route as UtilitiesRevisionDiffIndexImport } from './routes/utilities/revision-diff/index'
import { Route as TranslationsGlossaryIndexImport } from './routes/translations/glossary/index'
import { Route as TranslationsEditorIndexImport } from './routes/translations/editor/index'
import { Route as TranslationsCatIndexImport } from './routes/translations/cat/index'
import { Route as TranslationsAssignedIndexImport } from './routes/translations/assigned/index'
import { Route as SubscriptionSuccessIndexImport } from './routes/subscription/success/index'
import { Route as SubscriptionProgressIndexImport } from './routes/subscription/progress/index'
import { Route as SubscriptionFailIndexImport } from './routes/subscription/fail/index'
import { Route as SubscriptionChangeSuccessIndexImport } from './routes/subscription/change-success/index'
import { Route as SettingsUsageIndexImport } from './routes/settings/usage/index'
import { Route as SettingsIntegrationsIndexImport } from './routes/settings/integrations/index'
import { Route as SettingsHistoryIndexImport } from './routes/settings/history/index'
import { Route as SettingsBillingIndexImport } from './routes/settings/billing/index'
import { Route as SettingsAccountIndexImport } from './routes/settings/account/index'
import { Route as ReviewsNewIndexImport } from './routes/reviews/new/index'
import { Route as ReviewsReviewIdIndexImport } from './routes/reviews/$reviewId/index'
import { Route as ProjectsRenewalIndexImport } from './routes/projects/renewal/index'
import { Route as ProjectsNewIndexImport } from './routes/projects/new/index'
import { Route as OrdersOrderIdIndexImport } from './routes/orders/$orderId/index'
import { Route as MarketplaceLandingIndexImport } from './routes/marketplace/landing/index'
import { Route as MarketplaceErrorIndexImport } from './routes/marketplace/error/index'
import { Route as LoginSuccessIndexImport } from './routes/login/success/index'
import { Route as LegalPrivacyPolicyIndexImport } from './routes/legal/privacy-policy/index'
import { Route as AssistantUsageIndexImport } from './routes/assistant/usage/index'
import { Route as AssistantConversationIdIndexImport } from './routes/assistant/$conversationId/index'
import { Route as AdminUserIndexImport } from './routes/admin/user/index'
import { Route as AdminUnitRateIndexImport } from './routes/admin/unit-rate/index'
import { Route as AdminTranslationStatisticsIndexImport } from './routes/admin/translation-statistics/index'
import { Route as AdminTranslationCatalogIndexImport } from './routes/admin/translation-catalog/index'
import { Route as AdminSubscriptionsIndexImport } from './routes/admin/subscriptions/index'
import { Route as AdminPromptIndexImport } from './routes/admin/prompt/index'
import { Route as AdminPersonalPlanIndexImport } from './routes/admin/personal-plan/index'
import { Route as AdminOrganizationGroupsIndexImport } from './routes/admin/organization-groups/index'
import { Route as AdminFeedbackIndexImport } from './routes/admin/feedback/index'
import { Route as AdminCouponIndexImport } from './routes/admin/coupon/index'
import { Route as AdminBillingIndexImport } from './routes/admin/billing/index'
import { Route as TranslationsGlossaryIdIndexImport } from './routes/translations/glossary/$id/index'
import { Route as SettingsBillingBillingIdIndexImport } from './routes/settings/billing/$billingId/index'
import { Route as PmProjectsProjectIdIndexImport } from './routes/pm/projects/$projectId/index'
import { Route as OrdersAnonymousOrderIdIndexImport } from './routes/orders/anonymous/$orderId/index'
import { Route as OrdersOrderIdManageIndexImport } from './routes/orders/$orderId/manage/index'
import { Route as LegalTermsOfUseTypeIndexImport } from './routes/legal/terms-of-use/$type/index'
import { Route as LegalPrivacyPolicyEnIndexImport } from './routes/legal/privacy-policy/en/index'
import { Route as LegalPrivacyPolicy20230601IndexImport } from './routes/legal/privacy-policy/2023-06-01/index'
import { Route as AdminPromptPromptIdIndexImport } from './routes/admin/prompt/$promptId/index'
import { Route as AdminBillingAccountIdIndexImport } from './routes/admin/billing/$accountId/index'
import { Route as TranslationsJobsJobIdSmartGlossaryIndexImport } from './routes/translations/jobs/$jobId/smart-glossary/index'
import { Route as TranslationsJobsJobIdEditorIndexImport } from './routes/translations/jobs/$jobId/editor/index'
import { Route as TranslationsJobsJobIdCompareIndexImport } from './routes/translations/jobs/$jobId/compare/index'
import { Route as LegalTermsOfUseEnTypeIndexImport } from './routes/legal/terms-of-use/en/$type/index'
import { Route as LegalPrivacyPolicy20230601EnIndexImport } from './routes/legal/privacy-policy/2023-06-01/en/index'
import { Route as AdminUserAccountIdUsageIndexImport } from './routes/admin/user/$accountId/usage/index'
import { Route as AdminUserAccountIdSubscriptionIndexImport } from './routes/admin/user/$accountId/subscription/index'
import { Route as AdminPromptRubricRubricIdIndexImport } from './routes/admin/prompt/rubric/$rubricId/index'
import { Route as AdminBillingPaymentsPaymentIdIndexImport } from './routes/admin/billing/payments/$paymentId/index'
import { Route as TranslationsJobsJobIdEditorGuideImport } from './routes/translations/jobs/$jobId/editor/guide'

// Create/Update Routes

const PmRouteRoute = PmRouteImport.update({
  id: '/pm',
  path: '/pm',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UtilitiesIndexRoute = UtilitiesIndexImport.update({
  id: '/utilities/',
  path: '/utilities/',
  getParentRoute: () => rootRoute,
} as any)

const TranslatorsIndexRoute = TranslatorsIndexImport.update({
  id: '/translators/',
  path: '/translators/',
  getParentRoute: () => rootRoute,
} as any)

const TranslatorIndexRoute = TranslatorIndexImport.update({
  id: '/translator/',
  path: '/translator/',
  getParentRoute: () => rootRoute,
} as any)

const TranslationsIndexRoute = TranslationsIndexImport.update({
  id: '/translations/',
  path: '/translations/',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionIndexRoute = SubscriptionIndexImport.update({
  id: '/subscription/',
  path: '/subscription/',
  getParentRoute: () => rootRoute,
} as any)

const SignUpIndexRoute = SignUpIndexImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => rootRoute,
} as any)

const ReviewsIndexRoute = ReviewsIndexImport.update({
  id: '/reviews/',
  path: '/reviews/',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordIndexRoute = ResetPasswordIndexImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRoute,
} as any)

const ProjectsIndexRoute = ProjectsIndexImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRoute,
} as any)

const PmIndexRoute = PmIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PmRouteRoute,
} as any)

const OrdersIndexRoute = OrdersIndexImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRoute,
} as any)

const ClientsIndexRoute = ClientsIndexImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRoute,
} as any)

const AssistantIndexRoute = AssistantIndexImport.update({
  id: '/assistant/',
  path: '/assistant/',
  getParentRoute: () => rootRoute,
} as any)

const AccountsIndexRoute = AccountsIndexImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => rootRoute,
} as any)

const UtilitiesVerticalParallelIndexRoute =
  UtilitiesVerticalParallelIndexImport.update({
    id: '/utilities/vertical-parallel/',
    path: '/utilities/vertical-parallel/',
    getParentRoute: () => rootRoute,
  } as any)

const UtilitiesTextCounterIndexRoute = UtilitiesTextCounterIndexImport.update({
  id: '/utilities/text-counter/',
  path: '/utilities/text-counter/',
  getParentRoute: () => rootRoute,
} as any)

const UtilitiesRevisionDiffIndexRoute = UtilitiesRevisionDiffIndexImport.update(
  {
    id: '/utilities/revision-diff/',
    path: '/utilities/revision-diff/',
    getParentRoute: () => rootRoute,
  } as any,
)

const TranslationsGlossaryIndexRoute = TranslationsGlossaryIndexImport.update({
  id: '/translations/glossary/',
  path: '/translations/glossary/',
  getParentRoute: () => rootRoute,
} as any)

const TranslationsEditorIndexRoute = TranslationsEditorIndexImport.update({
  id: '/translations/editor/',
  path: '/translations/editor/',
  getParentRoute: () => rootRoute,
} as any)

const TranslationsCatIndexRoute = TranslationsCatIndexImport.update({
  id: '/translations/cat/',
  path: '/translations/cat/',
  getParentRoute: () => rootRoute,
} as any)

const TranslationsAssignedIndexRoute = TranslationsAssignedIndexImport.update({
  id: '/translations/assigned/',
  path: '/translations/assigned/',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionSuccessIndexRoute = SubscriptionSuccessIndexImport.update({
  id: '/subscription/success/',
  path: '/subscription/success/',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionProgressIndexRoute = SubscriptionProgressIndexImport.update({
  id: '/subscription/progress/',
  path: '/subscription/progress/',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionFailIndexRoute = SubscriptionFailIndexImport.update({
  id: '/subscription/fail/',
  path: '/subscription/fail/',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionChangeSuccessIndexRoute =
  SubscriptionChangeSuccessIndexImport.update({
    id: '/subscription/change-success/',
    path: '/subscription/change-success/',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsUsageIndexRoute = SettingsUsageIndexImport.update({
  id: '/settings/usage/',
  path: '/settings/usage/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsIntegrationsIndexRoute = SettingsIntegrationsIndexImport.update({
  id: '/settings/integrations/',
  path: '/settings/integrations/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsHistoryIndexRoute = SettingsHistoryIndexImport.update({
  id: '/settings/history/',
  path: '/settings/history/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsBillingIndexRoute = SettingsBillingIndexImport.update({
  id: '/settings/billing/',
  path: '/settings/billing/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsAccountIndexRoute = SettingsAccountIndexImport.update({
  id: '/settings/account/',
  path: '/settings/account/',
  getParentRoute: () => rootRoute,
} as any)

const ReviewsNewIndexRoute = ReviewsNewIndexImport.update({
  id: '/reviews/new/',
  path: '/reviews/new/',
  getParentRoute: () => rootRoute,
} as any)

const ReviewsReviewIdIndexRoute = ReviewsReviewIdIndexImport.update({
  id: '/reviews/$reviewId/',
  path: '/reviews/$reviewId/',
  getParentRoute: () => rootRoute,
} as any)

const ProjectsRenewalIndexRoute = ProjectsRenewalIndexImport.update({
  id: '/projects/renewal/',
  path: '/projects/renewal/',
  getParentRoute: () => rootRoute,
} as any)

const ProjectsNewIndexRoute = ProjectsNewIndexImport.update({
  id: '/projects/new/',
  path: '/projects/new/',
  getParentRoute: () => rootRoute,
} as any)

const OrdersOrderIdIndexRoute = OrdersOrderIdIndexImport.update({
  id: '/orders/$orderId/',
  path: '/orders/$orderId/',
  getParentRoute: () => rootRoute,
} as any)

const MarketplaceLandingIndexRoute = MarketplaceLandingIndexImport.update({
  id: '/marketplace/landing/',
  path: '/marketplace/landing/',
  getParentRoute: () => rootRoute,
} as any)

const MarketplaceErrorIndexRoute = MarketplaceErrorIndexImport.update({
  id: '/marketplace/error/',
  path: '/marketplace/error/',
  getParentRoute: () => rootRoute,
} as any)

const LoginSuccessIndexRoute = LoginSuccessIndexImport.update({
  id: '/login/success/',
  path: '/login/success/',
  getParentRoute: () => rootRoute,
} as any)

const LegalPrivacyPolicyIndexRoute = LegalPrivacyPolicyIndexImport.update({
  id: '/legal/privacy-policy/',
  path: '/legal/privacy-policy/',
  getParentRoute: () => rootRoute,
} as any)

const AssistantUsageIndexRoute = AssistantUsageIndexImport.update({
  id: '/assistant/usage/',
  path: '/assistant/usage/',
  getParentRoute: () => rootRoute,
} as any)

const AssistantConversationIdIndexRoute =
  AssistantConversationIdIndexImport.update({
    id: '/assistant/$conversationId/',
    path: '/assistant/$conversationId/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminUserIndexRoute = AdminUserIndexImport.update({
  id: '/admin/user/',
  path: '/admin/user/',
  getParentRoute: () => rootRoute,
} as any)

const AdminUnitRateIndexRoute = AdminUnitRateIndexImport.update({
  id: '/admin/unit-rate/',
  path: '/admin/unit-rate/',
  getParentRoute: () => rootRoute,
} as any)

const AdminTranslationStatisticsIndexRoute =
  AdminTranslationStatisticsIndexImport.update({
    id: '/admin/translation-statistics/',
    path: '/admin/translation-statistics/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminTranslationCatalogIndexRoute =
  AdminTranslationCatalogIndexImport.update({
    id: '/admin/translation-catalog/',
    path: '/admin/translation-catalog/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminSubscriptionsIndexRoute = AdminSubscriptionsIndexImport.update({
  id: '/admin/subscriptions/',
  path: '/admin/subscriptions/',
  getParentRoute: () => rootRoute,
} as any)

const AdminPromptIndexRoute = AdminPromptIndexImport.update({
  id: '/admin/prompt/',
  path: '/admin/prompt/',
  getParentRoute: () => rootRoute,
} as any)

const AdminPersonalPlanIndexRoute = AdminPersonalPlanIndexImport.update({
  id: '/admin/personal-plan/',
  path: '/admin/personal-plan/',
  getParentRoute: () => rootRoute,
} as any)

const AdminOrganizationGroupsIndexRoute =
  AdminOrganizationGroupsIndexImport.update({
    id: '/admin/organization-groups/',
    path: '/admin/organization-groups/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminFeedbackIndexRoute = AdminFeedbackIndexImport.update({
  id: '/admin/feedback/',
  path: '/admin/feedback/',
  getParentRoute: () => rootRoute,
} as any)

const AdminCouponIndexRoute = AdminCouponIndexImport.update({
  id: '/admin/coupon/',
  path: '/admin/coupon/',
  getParentRoute: () => rootRoute,
} as any)

const AdminBillingIndexRoute = AdminBillingIndexImport.update({
  id: '/admin/billing/',
  path: '/admin/billing/',
  getParentRoute: () => rootRoute,
} as any)

const TranslationsGlossaryIdIndexRoute =
  TranslationsGlossaryIdIndexImport.update({
    id: '/translations/glossary/$id/',
    path: '/translations/glossary/$id/',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsBillingBillingIdIndexRoute =
  SettingsBillingBillingIdIndexImport.update({
    id: '/settings/billing/$billingId/',
    path: '/settings/billing/$billingId/',
    getParentRoute: () => rootRoute,
  } as any)

const PmProjectsProjectIdIndexRoute = PmProjectsProjectIdIndexImport.update({
  id: '/projects/$projectId/',
  path: '/projects/$projectId/',
  getParentRoute: () => PmRouteRoute,
} as any)

const OrdersAnonymousOrderIdIndexRoute =
  OrdersAnonymousOrderIdIndexImport.update({
    id: '/orders/anonymous/$orderId/',
    path: '/orders/anonymous/$orderId/',
    getParentRoute: () => rootRoute,
  } as any)

const OrdersOrderIdManageIndexRoute = OrdersOrderIdManageIndexImport.update({
  id: '/orders/$orderId/manage/',
  path: '/orders/$orderId/manage/',
  getParentRoute: () => rootRoute,
} as any)

const LegalTermsOfUseTypeIndexRoute = LegalTermsOfUseTypeIndexImport.update({
  id: '/legal/terms-of-use/$type/',
  path: '/legal/terms-of-use/$type/',
  getParentRoute: () => rootRoute,
} as any)

const LegalPrivacyPolicyEnIndexRoute = LegalPrivacyPolicyEnIndexImport.update({
  id: '/legal/privacy-policy/en/',
  path: '/legal/privacy-policy/en/',
  getParentRoute: () => rootRoute,
} as any)

const LegalPrivacyPolicy20230601IndexRoute =
  LegalPrivacyPolicy20230601IndexImport.update({
    id: '/legal/privacy-policy/2023-06-01/',
    path: '/legal/privacy-policy/2023-06-01/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminPromptPromptIdIndexRoute = AdminPromptPromptIdIndexImport.update({
  id: '/admin/prompt/$promptId/',
  path: '/admin/prompt/$promptId/',
  getParentRoute: () => rootRoute,
} as any)

const AdminBillingAccountIdIndexRoute = AdminBillingAccountIdIndexImport.update(
  {
    id: '/admin/billing/$accountId/',
    path: '/admin/billing/$accountId/',
    getParentRoute: () => rootRoute,
  } as any,
)

const TranslationsJobsJobIdSmartGlossaryIndexRoute =
  TranslationsJobsJobIdSmartGlossaryIndexImport.update({
    id: '/translations/jobs/$jobId/smart-glossary/',
    path: '/translations/jobs/$jobId/smart-glossary/',
    getParentRoute: () => rootRoute,
  } as any)

const TranslationsJobsJobIdEditorIndexRoute =
  TranslationsJobsJobIdEditorIndexImport.update({
    id: '/translations/jobs/$jobId/editor/',
    path: '/translations/jobs/$jobId/editor/',
    getParentRoute: () => rootRoute,
  } as any)

const TranslationsJobsJobIdCompareIndexRoute =
  TranslationsJobsJobIdCompareIndexImport.update({
    id: '/translations/jobs/$jobId/compare/',
    path: '/translations/jobs/$jobId/compare/',
    getParentRoute: () => rootRoute,
  } as any)

const LegalTermsOfUseEnTypeIndexRoute = LegalTermsOfUseEnTypeIndexImport.update(
  {
    id: '/legal/terms-of-use/en/$type/',
    path: '/legal/terms-of-use/en/$type/',
    getParentRoute: () => rootRoute,
  } as any,
)

const LegalPrivacyPolicy20230601EnIndexRoute =
  LegalPrivacyPolicy20230601EnIndexImport.update({
    id: '/legal/privacy-policy/2023-06-01/en/',
    path: '/legal/privacy-policy/2023-06-01/en/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminUserAccountIdUsageIndexRoute =
  AdminUserAccountIdUsageIndexImport.update({
    id: '/admin/user/$accountId/usage/',
    path: '/admin/user/$accountId/usage/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminUserAccountIdSubscriptionIndexRoute =
  AdminUserAccountIdSubscriptionIndexImport.update({
    id: '/admin/user/$accountId/subscription/',
    path: '/admin/user/$accountId/subscription/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminPromptRubricRubricIdIndexRoute =
  AdminPromptRubricRubricIdIndexImport.update({
    id: '/admin/prompt/rubric/$rubricId/',
    path: '/admin/prompt/rubric/$rubricId/',
    getParentRoute: () => rootRoute,
  } as any)

const AdminBillingPaymentsPaymentIdIndexRoute =
  AdminBillingPaymentsPaymentIdIndexImport.update({
    id: '/admin/billing/payments/$paymentId/',
    path: '/admin/billing/payments/$paymentId/',
    getParentRoute: () => rootRoute,
  } as any)

const TranslationsJobsJobIdEditorGuideRoute =
  TranslationsJobsJobIdEditorGuideImport.update({
    id: '/translations/jobs/$jobId/editor/guide',
    path: '/translations/jobs/$jobId/editor/guide',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/pm': {
      id: '/pm'
      path: '/pm'
      fullPath: '/pm'
      preLoaderRoute: typeof PmRouteImport
      parentRoute: typeof rootRoute
    }
    '/accounts/': {
      id: '/accounts/'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AccountsIndexImport
      parentRoute: typeof rootRoute
    }
    '/assistant/': {
      id: '/assistant/'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AssistantIndexImport
      parentRoute: typeof rootRoute
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsIndexImport
      parentRoute: typeof rootRoute
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersIndexImport
      parentRoute: typeof rootRoute
    }
    '/pm/': {
      id: '/pm/'
      path: '/'
      fullPath: '/pm/'
      preLoaderRoute: typeof PmIndexImport
      parentRoute: typeof PmRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexImport
      parentRoute: typeof rootRoute
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/reviews/': {
      id: '/reviews/'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof ReviewsIndexImport
      parentRoute: typeof rootRoute
    }
    '/sign-up/': {
      id: '/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpIndexImport
      parentRoute: typeof rootRoute
    }
    '/subscription/': {
      id: '/subscription/'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/': {
      id: '/translations/'
      path: '/translations'
      fullPath: '/translations'
      preLoaderRoute: typeof TranslationsIndexImport
      parentRoute: typeof rootRoute
    }
    '/translator/': {
      id: '/translator/'
      path: '/translator'
      fullPath: '/translator'
      preLoaderRoute: typeof TranslatorIndexImport
      parentRoute: typeof rootRoute
    }
    '/translators/': {
      id: '/translators/'
      path: '/translators'
      fullPath: '/translators'
      preLoaderRoute: typeof TranslatorsIndexImport
      parentRoute: typeof rootRoute
    }
    '/utilities/': {
      id: '/utilities/'
      path: '/utilities'
      fullPath: '/utilities'
      preLoaderRoute: typeof UtilitiesIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/billing/': {
      id: '/admin/billing/'
      path: '/admin/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/coupon/': {
      id: '/admin/coupon/'
      path: '/admin/coupon'
      fullPath: '/admin/coupon'
      preLoaderRoute: typeof AdminCouponIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/feedback/': {
      id: '/admin/feedback/'
      path: '/admin/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/organization-groups/': {
      id: '/admin/organization-groups/'
      path: '/admin/organization-groups'
      fullPath: '/admin/organization-groups'
      preLoaderRoute: typeof AdminOrganizationGroupsIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/personal-plan/': {
      id: '/admin/personal-plan/'
      path: '/admin/personal-plan'
      fullPath: '/admin/personal-plan'
      preLoaderRoute: typeof AdminPersonalPlanIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/prompt/': {
      id: '/admin/prompt/'
      path: '/admin/prompt'
      fullPath: '/admin/prompt'
      preLoaderRoute: typeof AdminPromptIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/subscriptions/': {
      id: '/admin/subscriptions/'
      path: '/admin/subscriptions'
      fullPath: '/admin/subscriptions'
      preLoaderRoute: typeof AdminSubscriptionsIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/translation-catalog/': {
      id: '/admin/translation-catalog/'
      path: '/admin/translation-catalog'
      fullPath: '/admin/translation-catalog'
      preLoaderRoute: typeof AdminTranslationCatalogIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/translation-statistics/': {
      id: '/admin/translation-statistics/'
      path: '/admin/translation-statistics'
      fullPath: '/admin/translation-statistics'
      preLoaderRoute: typeof AdminTranslationStatisticsIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/unit-rate/': {
      id: '/admin/unit-rate/'
      path: '/admin/unit-rate'
      fullPath: '/admin/unit-rate'
      preLoaderRoute: typeof AdminUnitRateIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/user/': {
      id: '/admin/user/'
      path: '/admin/user'
      fullPath: '/admin/user'
      preLoaderRoute: typeof AdminUserIndexImport
      parentRoute: typeof rootRoute
    }
    '/assistant/$conversationId/': {
      id: '/assistant/$conversationId/'
      path: '/assistant/$conversationId'
      fullPath: '/assistant/$conversationId'
      preLoaderRoute: typeof AssistantConversationIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/assistant/usage/': {
      id: '/assistant/usage/'
      path: '/assistant/usage'
      fullPath: '/assistant/usage'
      preLoaderRoute: typeof AssistantUsageIndexImport
      parentRoute: typeof rootRoute
    }
    '/legal/privacy-policy/': {
      id: '/legal/privacy-policy/'
      path: '/legal/privacy-policy'
      fullPath: '/legal/privacy-policy'
      preLoaderRoute: typeof LegalPrivacyPolicyIndexImport
      parentRoute: typeof rootRoute
    }
    '/login/success/': {
      id: '/login/success/'
      path: '/login/success'
      fullPath: '/login/success'
      preLoaderRoute: typeof LoginSuccessIndexImport
      parentRoute: typeof rootRoute
    }
    '/marketplace/error/': {
      id: '/marketplace/error/'
      path: '/marketplace/error'
      fullPath: '/marketplace/error'
      preLoaderRoute: typeof MarketplaceErrorIndexImport
      parentRoute: typeof rootRoute
    }
    '/marketplace/landing/': {
      id: '/marketplace/landing/'
      path: '/marketplace/landing'
      fullPath: '/marketplace/landing'
      preLoaderRoute: typeof MarketplaceLandingIndexImport
      parentRoute: typeof rootRoute
    }
    '/orders/$orderId/': {
      id: '/orders/$orderId/'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/projects/new/': {
      id: '/projects/new/'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewIndexImport
      parentRoute: typeof rootRoute
    }
    '/projects/renewal/': {
      id: '/projects/renewal/'
      path: '/projects/renewal'
      fullPath: '/projects/renewal'
      preLoaderRoute: typeof ProjectsRenewalIndexImport
      parentRoute: typeof rootRoute
    }
    '/reviews/$reviewId/': {
      id: '/reviews/$reviewId/'
      path: '/reviews/$reviewId'
      fullPath: '/reviews/$reviewId'
      preLoaderRoute: typeof ReviewsReviewIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/reviews/new/': {
      id: '/reviews/new/'
      path: '/reviews/new'
      fullPath: '/reviews/new'
      preLoaderRoute: typeof ReviewsNewIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/account/': {
      id: '/settings/account/'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/billing/': {
      id: '/settings/billing/'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/history/': {
      id: '/settings/history/'
      path: '/settings/history'
      fullPath: '/settings/history'
      preLoaderRoute: typeof SettingsHistoryIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/integrations/': {
      id: '/settings/integrations/'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/usage/': {
      id: '/settings/usage/'
      path: '/settings/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof SettingsUsageIndexImport
      parentRoute: typeof rootRoute
    }
    '/subscription/change-success/': {
      id: '/subscription/change-success/'
      path: '/subscription/change-success'
      fullPath: '/subscription/change-success'
      preLoaderRoute: typeof SubscriptionChangeSuccessIndexImport
      parentRoute: typeof rootRoute
    }
    '/subscription/fail/': {
      id: '/subscription/fail/'
      path: '/subscription/fail'
      fullPath: '/subscription/fail'
      preLoaderRoute: typeof SubscriptionFailIndexImport
      parentRoute: typeof rootRoute
    }
    '/subscription/progress/': {
      id: '/subscription/progress/'
      path: '/subscription/progress'
      fullPath: '/subscription/progress'
      preLoaderRoute: typeof SubscriptionProgressIndexImport
      parentRoute: typeof rootRoute
    }
    '/subscription/success/': {
      id: '/subscription/success/'
      path: '/subscription/success'
      fullPath: '/subscription/success'
      preLoaderRoute: typeof SubscriptionSuccessIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/assigned/': {
      id: '/translations/assigned/'
      path: '/translations/assigned'
      fullPath: '/translations/assigned'
      preLoaderRoute: typeof TranslationsAssignedIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/cat/': {
      id: '/translations/cat/'
      path: '/translations/cat'
      fullPath: '/translations/cat'
      preLoaderRoute: typeof TranslationsCatIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/editor/': {
      id: '/translations/editor/'
      path: '/translations/editor'
      fullPath: '/translations/editor'
      preLoaderRoute: typeof TranslationsEditorIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/glossary/': {
      id: '/translations/glossary/'
      path: '/translations/glossary'
      fullPath: '/translations/glossary'
      preLoaderRoute: typeof TranslationsGlossaryIndexImport
      parentRoute: typeof rootRoute
    }
    '/utilities/revision-diff/': {
      id: '/utilities/revision-diff/'
      path: '/utilities/revision-diff'
      fullPath: '/utilities/revision-diff'
      preLoaderRoute: typeof UtilitiesRevisionDiffIndexImport
      parentRoute: typeof rootRoute
    }
    '/utilities/text-counter/': {
      id: '/utilities/text-counter/'
      path: '/utilities/text-counter'
      fullPath: '/utilities/text-counter'
      preLoaderRoute: typeof UtilitiesTextCounterIndexImport
      parentRoute: typeof rootRoute
    }
    '/utilities/vertical-parallel/': {
      id: '/utilities/vertical-parallel/'
      path: '/utilities/vertical-parallel'
      fullPath: '/utilities/vertical-parallel'
      preLoaderRoute: typeof UtilitiesVerticalParallelIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/billing/$accountId/': {
      id: '/admin/billing/$accountId/'
      path: '/admin/billing/$accountId'
      fullPath: '/admin/billing/$accountId'
      preLoaderRoute: typeof AdminBillingAccountIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/prompt/$promptId/': {
      id: '/admin/prompt/$promptId/'
      path: '/admin/prompt/$promptId'
      fullPath: '/admin/prompt/$promptId'
      preLoaderRoute: typeof AdminPromptPromptIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/legal/privacy-policy/2023-06-01/': {
      id: '/legal/privacy-policy/2023-06-01/'
      path: '/legal/privacy-policy/2023-06-01'
      fullPath: '/legal/privacy-policy/2023-06-01'
      preLoaderRoute: typeof LegalPrivacyPolicy20230601IndexImport
      parentRoute: typeof rootRoute
    }
    '/legal/privacy-policy/en/': {
      id: '/legal/privacy-policy/en/'
      path: '/legal/privacy-policy/en'
      fullPath: '/legal/privacy-policy/en'
      preLoaderRoute: typeof LegalPrivacyPolicyEnIndexImport
      parentRoute: typeof rootRoute
    }
    '/legal/terms-of-use/$type/': {
      id: '/legal/terms-of-use/$type/'
      path: '/legal/terms-of-use/$type'
      fullPath: '/legal/terms-of-use/$type'
      preLoaderRoute: typeof LegalTermsOfUseTypeIndexImport
      parentRoute: typeof rootRoute
    }
    '/orders/$orderId/manage/': {
      id: '/orders/$orderId/manage/'
      path: '/orders/$orderId/manage'
      fullPath: '/orders/$orderId/manage'
      preLoaderRoute: typeof OrdersOrderIdManageIndexImport
      parentRoute: typeof rootRoute
    }
    '/orders/anonymous/$orderId/': {
      id: '/orders/anonymous/$orderId/'
      path: '/orders/anonymous/$orderId'
      fullPath: '/orders/anonymous/$orderId'
      preLoaderRoute: typeof OrdersAnonymousOrderIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/pm/projects/$projectId/': {
      id: '/pm/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/pm/projects/$projectId'
      preLoaderRoute: typeof PmProjectsProjectIdIndexImport
      parentRoute: typeof PmRouteImport
    }
    '/settings/billing/$billingId/': {
      id: '/settings/billing/$billingId/'
      path: '/settings/billing/$billingId'
      fullPath: '/settings/billing/$billingId'
      preLoaderRoute: typeof SettingsBillingBillingIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/glossary/$id/': {
      id: '/translations/glossary/$id/'
      path: '/translations/glossary/$id'
      fullPath: '/translations/glossary/$id'
      preLoaderRoute: typeof TranslationsGlossaryIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/jobs/$jobId/editor/guide': {
      id: '/translations/jobs/$jobId/editor/guide'
      path: '/translations/jobs/$jobId/editor/guide'
      fullPath: '/translations/jobs/$jobId/editor/guide'
      preLoaderRoute: typeof TranslationsJobsJobIdEditorGuideImport
      parentRoute: typeof rootRoute
    }
    '/admin/billing/payments/$paymentId/': {
      id: '/admin/billing/payments/$paymentId/'
      path: '/admin/billing/payments/$paymentId'
      fullPath: '/admin/billing/payments/$paymentId'
      preLoaderRoute: typeof AdminBillingPaymentsPaymentIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/prompt/rubric/$rubricId/': {
      id: '/admin/prompt/rubric/$rubricId/'
      path: '/admin/prompt/rubric/$rubricId'
      fullPath: '/admin/prompt/rubric/$rubricId'
      preLoaderRoute: typeof AdminPromptRubricRubricIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/user/$accountId/subscription/': {
      id: '/admin/user/$accountId/subscription/'
      path: '/admin/user/$accountId/subscription'
      fullPath: '/admin/user/$accountId/subscription'
      preLoaderRoute: typeof AdminUserAccountIdSubscriptionIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/user/$accountId/usage/': {
      id: '/admin/user/$accountId/usage/'
      path: '/admin/user/$accountId/usage'
      fullPath: '/admin/user/$accountId/usage'
      preLoaderRoute: typeof AdminUserAccountIdUsageIndexImport
      parentRoute: typeof rootRoute
    }
    '/legal/privacy-policy/2023-06-01/en/': {
      id: '/legal/privacy-policy/2023-06-01/en/'
      path: '/legal/privacy-policy/2023-06-01/en'
      fullPath: '/legal/privacy-policy/2023-06-01/en'
      preLoaderRoute: typeof LegalPrivacyPolicy20230601EnIndexImport
      parentRoute: typeof rootRoute
    }
    '/legal/terms-of-use/en/$type/': {
      id: '/legal/terms-of-use/en/$type/'
      path: '/legal/terms-of-use/en/$type'
      fullPath: '/legal/terms-of-use/en/$type'
      preLoaderRoute: typeof LegalTermsOfUseEnTypeIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/jobs/$jobId/compare/': {
      id: '/translations/jobs/$jobId/compare/'
      path: '/translations/jobs/$jobId/compare'
      fullPath: '/translations/jobs/$jobId/compare'
      preLoaderRoute: typeof TranslationsJobsJobIdCompareIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/jobs/$jobId/editor/': {
      id: '/translations/jobs/$jobId/editor/'
      path: '/translations/jobs/$jobId/editor'
      fullPath: '/translations/jobs/$jobId/editor'
      preLoaderRoute: typeof TranslationsJobsJobIdEditorIndexImport
      parentRoute: typeof rootRoute
    }
    '/translations/jobs/$jobId/smart-glossary/': {
      id: '/translations/jobs/$jobId/smart-glossary/'
      path: '/translations/jobs/$jobId/smart-glossary'
      fullPath: '/translations/jobs/$jobId/smart-glossary'
      preLoaderRoute: typeof TranslationsJobsJobIdSmartGlossaryIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface PmRouteRouteChildren {
  PmIndexRoute: typeof PmIndexRoute
  PmProjectsProjectIdIndexRoute: typeof PmProjectsProjectIdIndexRoute
}

const PmRouteRouteChildren: PmRouteRouteChildren = {
  PmIndexRoute: PmIndexRoute,
  PmProjectsProjectIdIndexRoute: PmProjectsProjectIdIndexRoute,
}

const PmRouteRouteWithChildren =
  PmRouteRoute._addFileChildren(PmRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/pm': typeof PmRouteRouteWithChildren
  '/accounts': typeof AccountsIndexRoute
  '/assistant': typeof AssistantIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/pm/': typeof PmIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/reviews': typeof ReviewsIndexRoute
  '/sign-up': typeof SignUpIndexRoute
  '/subscription': typeof SubscriptionIndexRoute
  '/translations': typeof TranslationsIndexRoute
  '/translator': typeof TranslatorIndexRoute
  '/translators': typeof TranslatorsIndexRoute
  '/utilities': typeof UtilitiesIndexRoute
  '/admin/billing': typeof AdminBillingIndexRoute
  '/admin/coupon': typeof AdminCouponIndexRoute
  '/admin/feedback': typeof AdminFeedbackIndexRoute
  '/admin/organization-groups': typeof AdminOrganizationGroupsIndexRoute
  '/admin/personal-plan': typeof AdminPersonalPlanIndexRoute
  '/admin/prompt': typeof AdminPromptIndexRoute
  '/admin/subscriptions': typeof AdminSubscriptionsIndexRoute
  '/admin/translation-catalog': typeof AdminTranslationCatalogIndexRoute
  '/admin/translation-statistics': typeof AdminTranslationStatisticsIndexRoute
  '/admin/unit-rate': typeof AdminUnitRateIndexRoute
  '/admin/user': typeof AdminUserIndexRoute
  '/assistant/$conversationId': typeof AssistantConversationIdIndexRoute
  '/assistant/usage': typeof AssistantUsageIndexRoute
  '/legal/privacy-policy': typeof LegalPrivacyPolicyIndexRoute
  '/login/success': typeof LoginSuccessIndexRoute
  '/marketplace/error': typeof MarketplaceErrorIndexRoute
  '/marketplace/landing': typeof MarketplaceLandingIndexRoute
  '/orders/$orderId': typeof OrdersOrderIdIndexRoute
  '/projects/new': typeof ProjectsNewIndexRoute
  '/projects/renewal': typeof ProjectsRenewalIndexRoute
  '/reviews/$reviewId': typeof ReviewsReviewIdIndexRoute
  '/reviews/new': typeof ReviewsNewIndexRoute
  '/settings/account': typeof SettingsAccountIndexRoute
  '/settings/billing': typeof SettingsBillingIndexRoute
  '/settings/history': typeof SettingsHistoryIndexRoute
  '/settings/integrations': typeof SettingsIntegrationsIndexRoute
  '/settings/usage': typeof SettingsUsageIndexRoute
  '/subscription/change-success': typeof SubscriptionChangeSuccessIndexRoute
  '/subscription/fail': typeof SubscriptionFailIndexRoute
  '/subscription/progress': typeof SubscriptionProgressIndexRoute
  '/subscription/success': typeof SubscriptionSuccessIndexRoute
  '/translations/assigned': typeof TranslationsAssignedIndexRoute
  '/translations/cat': typeof TranslationsCatIndexRoute
  '/translations/editor': typeof TranslationsEditorIndexRoute
  '/translations/glossary': typeof TranslationsGlossaryIndexRoute
  '/utilities/revision-diff': typeof UtilitiesRevisionDiffIndexRoute
  '/utilities/text-counter': typeof UtilitiesTextCounterIndexRoute
  '/utilities/vertical-parallel': typeof UtilitiesVerticalParallelIndexRoute
  '/admin/billing/$accountId': typeof AdminBillingAccountIdIndexRoute
  '/admin/prompt/$promptId': typeof AdminPromptPromptIdIndexRoute
  '/legal/privacy-policy/2023-06-01': typeof LegalPrivacyPolicy20230601IndexRoute
  '/legal/privacy-policy/en': typeof LegalPrivacyPolicyEnIndexRoute
  '/legal/terms-of-use/$type': typeof LegalTermsOfUseTypeIndexRoute
  '/orders/$orderId/manage': typeof OrdersOrderIdManageIndexRoute
  '/orders/anonymous/$orderId': typeof OrdersAnonymousOrderIdIndexRoute
  '/pm/projects/$projectId': typeof PmProjectsProjectIdIndexRoute
  '/settings/billing/$billingId': typeof SettingsBillingBillingIdIndexRoute
  '/translations/glossary/$id': typeof TranslationsGlossaryIdIndexRoute
  '/translations/jobs/$jobId/editor/guide': typeof TranslationsJobsJobIdEditorGuideRoute
  '/admin/billing/payments/$paymentId': typeof AdminBillingPaymentsPaymentIdIndexRoute
  '/admin/prompt/rubric/$rubricId': typeof AdminPromptRubricRubricIdIndexRoute
  '/admin/user/$accountId/subscription': typeof AdminUserAccountIdSubscriptionIndexRoute
  '/admin/user/$accountId/usage': typeof AdminUserAccountIdUsageIndexRoute
  '/legal/privacy-policy/2023-06-01/en': typeof LegalPrivacyPolicy20230601EnIndexRoute
  '/legal/terms-of-use/en/$type': typeof LegalTermsOfUseEnTypeIndexRoute
  '/translations/jobs/$jobId/compare': typeof TranslationsJobsJobIdCompareIndexRoute
  '/translations/jobs/$jobId/editor': typeof TranslationsJobsJobIdEditorIndexRoute
  '/translations/jobs/$jobId/smart-glossary': typeof TranslationsJobsJobIdSmartGlossaryIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsIndexRoute
  '/assistant': typeof AssistantIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/pm': typeof PmIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/reviews': typeof ReviewsIndexRoute
  '/sign-up': typeof SignUpIndexRoute
  '/subscription': typeof SubscriptionIndexRoute
  '/translations': typeof TranslationsIndexRoute
  '/translator': typeof TranslatorIndexRoute
  '/translators': typeof TranslatorsIndexRoute
  '/utilities': typeof UtilitiesIndexRoute
  '/admin/billing': typeof AdminBillingIndexRoute
  '/admin/coupon': typeof AdminCouponIndexRoute
  '/admin/feedback': typeof AdminFeedbackIndexRoute
  '/admin/organization-groups': typeof AdminOrganizationGroupsIndexRoute
  '/admin/personal-plan': typeof AdminPersonalPlanIndexRoute
  '/admin/prompt': typeof AdminPromptIndexRoute
  '/admin/subscriptions': typeof AdminSubscriptionsIndexRoute
  '/admin/translation-catalog': typeof AdminTranslationCatalogIndexRoute
  '/admin/translation-statistics': typeof AdminTranslationStatisticsIndexRoute
  '/admin/unit-rate': typeof AdminUnitRateIndexRoute
  '/admin/user': typeof AdminUserIndexRoute
  '/assistant/$conversationId': typeof AssistantConversationIdIndexRoute
  '/assistant/usage': typeof AssistantUsageIndexRoute
  '/legal/privacy-policy': typeof LegalPrivacyPolicyIndexRoute
  '/login/success': typeof LoginSuccessIndexRoute
  '/marketplace/error': typeof MarketplaceErrorIndexRoute
  '/marketplace/landing': typeof MarketplaceLandingIndexRoute
  '/orders/$orderId': typeof OrdersOrderIdIndexRoute
  '/projects/new': typeof ProjectsNewIndexRoute
  '/projects/renewal': typeof ProjectsRenewalIndexRoute
  '/reviews/$reviewId': typeof ReviewsReviewIdIndexRoute
  '/reviews/new': typeof ReviewsNewIndexRoute
  '/settings/account': typeof SettingsAccountIndexRoute
  '/settings/billing': typeof SettingsBillingIndexRoute
  '/settings/history': typeof SettingsHistoryIndexRoute
  '/settings/integrations': typeof SettingsIntegrationsIndexRoute
  '/settings/usage': typeof SettingsUsageIndexRoute
  '/subscription/change-success': typeof SubscriptionChangeSuccessIndexRoute
  '/subscription/fail': typeof SubscriptionFailIndexRoute
  '/subscription/progress': typeof SubscriptionProgressIndexRoute
  '/subscription/success': typeof SubscriptionSuccessIndexRoute
  '/translations/assigned': typeof TranslationsAssignedIndexRoute
  '/translations/cat': typeof TranslationsCatIndexRoute
  '/translations/editor': typeof TranslationsEditorIndexRoute
  '/translations/glossary': typeof TranslationsGlossaryIndexRoute
  '/utilities/revision-diff': typeof UtilitiesRevisionDiffIndexRoute
  '/utilities/text-counter': typeof UtilitiesTextCounterIndexRoute
  '/utilities/vertical-parallel': typeof UtilitiesVerticalParallelIndexRoute
  '/admin/billing/$accountId': typeof AdminBillingAccountIdIndexRoute
  '/admin/prompt/$promptId': typeof AdminPromptPromptIdIndexRoute
  '/legal/privacy-policy/2023-06-01': typeof LegalPrivacyPolicy20230601IndexRoute
  '/legal/privacy-policy/en': typeof LegalPrivacyPolicyEnIndexRoute
  '/legal/terms-of-use/$type': typeof LegalTermsOfUseTypeIndexRoute
  '/orders/$orderId/manage': typeof OrdersOrderIdManageIndexRoute
  '/orders/anonymous/$orderId': typeof OrdersAnonymousOrderIdIndexRoute
  '/pm/projects/$projectId': typeof PmProjectsProjectIdIndexRoute
  '/settings/billing/$billingId': typeof SettingsBillingBillingIdIndexRoute
  '/translations/glossary/$id': typeof TranslationsGlossaryIdIndexRoute
  '/translations/jobs/$jobId/editor/guide': typeof TranslationsJobsJobIdEditorGuideRoute
  '/admin/billing/payments/$paymentId': typeof AdminBillingPaymentsPaymentIdIndexRoute
  '/admin/prompt/rubric/$rubricId': typeof AdminPromptRubricRubricIdIndexRoute
  '/admin/user/$accountId/subscription': typeof AdminUserAccountIdSubscriptionIndexRoute
  '/admin/user/$accountId/usage': typeof AdminUserAccountIdUsageIndexRoute
  '/legal/privacy-policy/2023-06-01/en': typeof LegalPrivacyPolicy20230601EnIndexRoute
  '/legal/terms-of-use/en/$type': typeof LegalTermsOfUseEnTypeIndexRoute
  '/translations/jobs/$jobId/compare': typeof TranslationsJobsJobIdCompareIndexRoute
  '/translations/jobs/$jobId/editor': typeof TranslationsJobsJobIdEditorIndexRoute
  '/translations/jobs/$jobId/smart-glossary': typeof TranslationsJobsJobIdSmartGlossaryIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/pm': typeof PmRouteRouteWithChildren
  '/accounts/': typeof AccountsIndexRoute
  '/assistant/': typeof AssistantIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/pm/': typeof PmIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/reviews/': typeof ReviewsIndexRoute
  '/sign-up/': typeof SignUpIndexRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/translations/': typeof TranslationsIndexRoute
  '/translator/': typeof TranslatorIndexRoute
  '/translators/': typeof TranslatorsIndexRoute
  '/utilities/': typeof UtilitiesIndexRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/coupon/': typeof AdminCouponIndexRoute
  '/admin/feedback/': typeof AdminFeedbackIndexRoute
  '/admin/organization-groups/': typeof AdminOrganizationGroupsIndexRoute
  '/admin/personal-plan/': typeof AdminPersonalPlanIndexRoute
  '/admin/prompt/': typeof AdminPromptIndexRoute
  '/admin/subscriptions/': typeof AdminSubscriptionsIndexRoute
  '/admin/translation-catalog/': typeof AdminTranslationCatalogIndexRoute
  '/admin/translation-statistics/': typeof AdminTranslationStatisticsIndexRoute
  '/admin/unit-rate/': typeof AdminUnitRateIndexRoute
  '/admin/user/': typeof AdminUserIndexRoute
  '/assistant/$conversationId/': typeof AssistantConversationIdIndexRoute
  '/assistant/usage/': typeof AssistantUsageIndexRoute
  '/legal/privacy-policy/': typeof LegalPrivacyPolicyIndexRoute
  '/login/success/': typeof LoginSuccessIndexRoute
  '/marketplace/error/': typeof MarketplaceErrorIndexRoute
  '/marketplace/landing/': typeof MarketplaceLandingIndexRoute
  '/orders/$orderId/': typeof OrdersOrderIdIndexRoute
  '/projects/new/': typeof ProjectsNewIndexRoute
  '/projects/renewal/': typeof ProjectsRenewalIndexRoute
  '/reviews/$reviewId/': typeof ReviewsReviewIdIndexRoute
  '/reviews/new/': typeof ReviewsNewIndexRoute
  '/settings/account/': typeof SettingsAccountIndexRoute
  '/settings/billing/': typeof SettingsBillingIndexRoute
  '/settings/history/': typeof SettingsHistoryIndexRoute
  '/settings/integrations/': typeof SettingsIntegrationsIndexRoute
  '/settings/usage/': typeof SettingsUsageIndexRoute
  '/subscription/change-success/': typeof SubscriptionChangeSuccessIndexRoute
  '/subscription/fail/': typeof SubscriptionFailIndexRoute
  '/subscription/progress/': typeof SubscriptionProgressIndexRoute
  '/subscription/success/': typeof SubscriptionSuccessIndexRoute
  '/translations/assigned/': typeof TranslationsAssignedIndexRoute
  '/translations/cat/': typeof TranslationsCatIndexRoute
  '/translations/editor/': typeof TranslationsEditorIndexRoute
  '/translations/glossary/': typeof TranslationsGlossaryIndexRoute
  '/utilities/revision-diff/': typeof UtilitiesRevisionDiffIndexRoute
  '/utilities/text-counter/': typeof UtilitiesTextCounterIndexRoute
  '/utilities/vertical-parallel/': typeof UtilitiesVerticalParallelIndexRoute
  '/admin/billing/$accountId/': typeof AdminBillingAccountIdIndexRoute
  '/admin/prompt/$promptId/': typeof AdminPromptPromptIdIndexRoute
  '/legal/privacy-policy/2023-06-01/': typeof LegalPrivacyPolicy20230601IndexRoute
  '/legal/privacy-policy/en/': typeof LegalPrivacyPolicyEnIndexRoute
  '/legal/terms-of-use/$type/': typeof LegalTermsOfUseTypeIndexRoute
  '/orders/$orderId/manage/': typeof OrdersOrderIdManageIndexRoute
  '/orders/anonymous/$orderId/': typeof OrdersAnonymousOrderIdIndexRoute
  '/pm/projects/$projectId/': typeof PmProjectsProjectIdIndexRoute
  '/settings/billing/$billingId/': typeof SettingsBillingBillingIdIndexRoute
  '/translations/glossary/$id/': typeof TranslationsGlossaryIdIndexRoute
  '/translations/jobs/$jobId/editor/guide': typeof TranslationsJobsJobIdEditorGuideRoute
  '/admin/billing/payments/$paymentId/': typeof AdminBillingPaymentsPaymentIdIndexRoute
  '/admin/prompt/rubric/$rubricId/': typeof AdminPromptRubricRubricIdIndexRoute
  '/admin/user/$accountId/subscription/': typeof AdminUserAccountIdSubscriptionIndexRoute
  '/admin/user/$accountId/usage/': typeof AdminUserAccountIdUsageIndexRoute
  '/legal/privacy-policy/2023-06-01/en/': typeof LegalPrivacyPolicy20230601EnIndexRoute
  '/legal/terms-of-use/en/$type/': typeof LegalTermsOfUseEnTypeIndexRoute
  '/translations/jobs/$jobId/compare/': typeof TranslationsJobsJobIdCompareIndexRoute
  '/translations/jobs/$jobId/editor/': typeof TranslationsJobsJobIdEditorIndexRoute
  '/translations/jobs/$jobId/smart-glossary/': typeof TranslationsJobsJobIdSmartGlossaryIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/pm'
    | '/accounts'
    | '/assistant'
    | '/clients'
    | '/orders'
    | '/pm/'
    | '/projects'
    | '/reset-password'
    | '/reviews'
    | '/sign-up'
    | '/subscription'
    | '/translations'
    | '/translator'
    | '/translators'
    | '/utilities'
    | '/admin/billing'
    | '/admin/coupon'
    | '/admin/feedback'
    | '/admin/organization-groups'
    | '/admin/personal-plan'
    | '/admin/prompt'
    | '/admin/subscriptions'
    | '/admin/translation-catalog'
    | '/admin/translation-statistics'
    | '/admin/unit-rate'
    | '/admin/user'
    | '/assistant/$conversationId'
    | '/assistant/usage'
    | '/legal/privacy-policy'
    | '/login/success'
    | '/marketplace/error'
    | '/marketplace/landing'
    | '/orders/$orderId'
    | '/projects/new'
    | '/projects/renewal'
    | '/reviews/$reviewId'
    | '/reviews/new'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/history'
    | '/settings/integrations'
    | '/settings/usage'
    | '/subscription/change-success'
    | '/subscription/fail'
    | '/subscription/progress'
    | '/subscription/success'
    | '/translations/assigned'
    | '/translations/cat'
    | '/translations/editor'
    | '/translations/glossary'
    | '/utilities/revision-diff'
    | '/utilities/text-counter'
    | '/utilities/vertical-parallel'
    | '/admin/billing/$accountId'
    | '/admin/prompt/$promptId'
    | '/legal/privacy-policy/2023-06-01'
    | '/legal/privacy-policy/en'
    | '/legal/terms-of-use/$type'
    | '/orders/$orderId/manage'
    | '/orders/anonymous/$orderId'
    | '/pm/projects/$projectId'
    | '/settings/billing/$billingId'
    | '/translations/glossary/$id'
    | '/translations/jobs/$jobId/editor/guide'
    | '/admin/billing/payments/$paymentId'
    | '/admin/prompt/rubric/$rubricId'
    | '/admin/user/$accountId/subscription'
    | '/admin/user/$accountId/usage'
    | '/legal/privacy-policy/2023-06-01/en'
    | '/legal/terms-of-use/en/$type'
    | '/translations/jobs/$jobId/compare'
    | '/translations/jobs/$jobId/editor'
    | '/translations/jobs/$jobId/smart-glossary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accounts'
    | '/assistant'
    | '/clients'
    | '/orders'
    | '/pm'
    | '/projects'
    | '/reset-password'
    | '/reviews'
    | '/sign-up'
    | '/subscription'
    | '/translations'
    | '/translator'
    | '/translators'
    | '/utilities'
    | '/admin/billing'
    | '/admin/coupon'
    | '/admin/feedback'
    | '/admin/organization-groups'
    | '/admin/personal-plan'
    | '/admin/prompt'
    | '/admin/subscriptions'
    | '/admin/translation-catalog'
    | '/admin/translation-statistics'
    | '/admin/unit-rate'
    | '/admin/user'
    | '/assistant/$conversationId'
    | '/assistant/usage'
    | '/legal/privacy-policy'
    | '/login/success'
    | '/marketplace/error'
    | '/marketplace/landing'
    | '/orders/$orderId'
    | '/projects/new'
    | '/projects/renewal'
    | '/reviews/$reviewId'
    | '/reviews/new'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/history'
    | '/settings/integrations'
    | '/settings/usage'
    | '/subscription/change-success'
    | '/subscription/fail'
    | '/subscription/progress'
    | '/subscription/success'
    | '/translations/assigned'
    | '/translations/cat'
    | '/translations/editor'
    | '/translations/glossary'
    | '/utilities/revision-diff'
    | '/utilities/text-counter'
    | '/utilities/vertical-parallel'
    | '/admin/billing/$accountId'
    | '/admin/prompt/$promptId'
    | '/legal/privacy-policy/2023-06-01'
    | '/legal/privacy-policy/en'
    | '/legal/terms-of-use/$type'
    | '/orders/$orderId/manage'
    | '/orders/anonymous/$orderId'
    | '/pm/projects/$projectId'
    | '/settings/billing/$billingId'
    | '/translations/glossary/$id'
    | '/translations/jobs/$jobId/editor/guide'
    | '/admin/billing/payments/$paymentId'
    | '/admin/prompt/rubric/$rubricId'
    | '/admin/user/$accountId/subscription'
    | '/admin/user/$accountId/usage'
    | '/legal/privacy-policy/2023-06-01/en'
    | '/legal/terms-of-use/en/$type'
    | '/translations/jobs/$jobId/compare'
    | '/translations/jobs/$jobId/editor'
    | '/translations/jobs/$jobId/smart-glossary'
  id:
    | '__root__'
    | '/'
    | '/pm'
    | '/accounts/'
    | '/assistant/'
    | '/clients/'
    | '/orders/'
    | '/pm/'
    | '/projects/'
    | '/reset-password/'
    | '/reviews/'
    | '/sign-up/'
    | '/subscription/'
    | '/translations/'
    | '/translator/'
    | '/translators/'
    | '/utilities/'
    | '/admin/billing/'
    | '/admin/coupon/'
    | '/admin/feedback/'
    | '/admin/organization-groups/'
    | '/admin/personal-plan/'
    | '/admin/prompt/'
    | '/admin/subscriptions/'
    | '/admin/translation-catalog/'
    | '/admin/translation-statistics/'
    | '/admin/unit-rate/'
    | '/admin/user/'
    | '/assistant/$conversationId/'
    | '/assistant/usage/'
    | '/legal/privacy-policy/'
    | '/login/success/'
    | '/marketplace/error/'
    | '/marketplace/landing/'
    | '/orders/$orderId/'
    | '/projects/new/'
    | '/projects/renewal/'
    | '/reviews/$reviewId/'
    | '/reviews/new/'
    | '/settings/account/'
    | '/settings/billing/'
    | '/settings/history/'
    | '/settings/integrations/'
    | '/settings/usage/'
    | '/subscription/change-success/'
    | '/subscription/fail/'
    | '/subscription/progress/'
    | '/subscription/success/'
    | '/translations/assigned/'
    | '/translations/cat/'
    | '/translations/editor/'
    | '/translations/glossary/'
    | '/utilities/revision-diff/'
    | '/utilities/text-counter/'
    | '/utilities/vertical-parallel/'
    | '/admin/billing/$accountId/'
    | '/admin/prompt/$promptId/'
    | '/legal/privacy-policy/2023-06-01/'
    | '/legal/privacy-policy/en/'
    | '/legal/terms-of-use/$type/'
    | '/orders/$orderId/manage/'
    | '/orders/anonymous/$orderId/'
    | '/pm/projects/$projectId/'
    | '/settings/billing/$billingId/'
    | '/translations/glossary/$id/'
    | '/translations/jobs/$jobId/editor/guide'
    | '/admin/billing/payments/$paymentId/'
    | '/admin/prompt/rubric/$rubricId/'
    | '/admin/user/$accountId/subscription/'
    | '/admin/user/$accountId/usage/'
    | '/legal/privacy-policy/2023-06-01/en/'
    | '/legal/terms-of-use/en/$type/'
    | '/translations/jobs/$jobId/compare/'
    | '/translations/jobs/$jobId/editor/'
    | '/translations/jobs/$jobId/smart-glossary/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PmRouteRoute: typeof PmRouteRouteWithChildren
  AccountsIndexRoute: typeof AccountsIndexRoute
  AssistantIndexRoute: typeof AssistantIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  ReviewsIndexRoute: typeof ReviewsIndexRoute
  SignUpIndexRoute: typeof SignUpIndexRoute
  SubscriptionIndexRoute: typeof SubscriptionIndexRoute
  TranslationsIndexRoute: typeof TranslationsIndexRoute
  TranslatorIndexRoute: typeof TranslatorIndexRoute
  TranslatorsIndexRoute: typeof TranslatorsIndexRoute
  UtilitiesIndexRoute: typeof UtilitiesIndexRoute
  AdminBillingIndexRoute: typeof AdminBillingIndexRoute
  AdminCouponIndexRoute: typeof AdminCouponIndexRoute
  AdminFeedbackIndexRoute: typeof AdminFeedbackIndexRoute
  AdminOrganizationGroupsIndexRoute: typeof AdminOrganizationGroupsIndexRoute
  AdminPersonalPlanIndexRoute: typeof AdminPersonalPlanIndexRoute
  AdminPromptIndexRoute: typeof AdminPromptIndexRoute
  AdminSubscriptionsIndexRoute: typeof AdminSubscriptionsIndexRoute
  AdminTranslationCatalogIndexRoute: typeof AdminTranslationCatalogIndexRoute
  AdminTranslationStatisticsIndexRoute: typeof AdminTranslationStatisticsIndexRoute
  AdminUnitRateIndexRoute: typeof AdminUnitRateIndexRoute
  AdminUserIndexRoute: typeof AdminUserIndexRoute
  AssistantConversationIdIndexRoute: typeof AssistantConversationIdIndexRoute
  AssistantUsageIndexRoute: typeof AssistantUsageIndexRoute
  LegalPrivacyPolicyIndexRoute: typeof LegalPrivacyPolicyIndexRoute
  LoginSuccessIndexRoute: typeof LoginSuccessIndexRoute
  MarketplaceErrorIndexRoute: typeof MarketplaceErrorIndexRoute
  MarketplaceLandingIndexRoute: typeof MarketplaceLandingIndexRoute
  OrdersOrderIdIndexRoute: typeof OrdersOrderIdIndexRoute
  ProjectsNewIndexRoute: typeof ProjectsNewIndexRoute
  ProjectsRenewalIndexRoute: typeof ProjectsRenewalIndexRoute
  ReviewsReviewIdIndexRoute: typeof ReviewsReviewIdIndexRoute
  ReviewsNewIndexRoute: typeof ReviewsNewIndexRoute
  SettingsAccountIndexRoute: typeof SettingsAccountIndexRoute
  SettingsBillingIndexRoute: typeof SettingsBillingIndexRoute
  SettingsHistoryIndexRoute: typeof SettingsHistoryIndexRoute
  SettingsIntegrationsIndexRoute: typeof SettingsIntegrationsIndexRoute
  SettingsUsageIndexRoute: typeof SettingsUsageIndexRoute
  SubscriptionChangeSuccessIndexRoute: typeof SubscriptionChangeSuccessIndexRoute
  SubscriptionFailIndexRoute: typeof SubscriptionFailIndexRoute
  SubscriptionProgressIndexRoute: typeof SubscriptionProgressIndexRoute
  SubscriptionSuccessIndexRoute: typeof SubscriptionSuccessIndexRoute
  TranslationsAssignedIndexRoute: typeof TranslationsAssignedIndexRoute
  TranslationsCatIndexRoute: typeof TranslationsCatIndexRoute
  TranslationsEditorIndexRoute: typeof TranslationsEditorIndexRoute
  TranslationsGlossaryIndexRoute: typeof TranslationsGlossaryIndexRoute
  UtilitiesRevisionDiffIndexRoute: typeof UtilitiesRevisionDiffIndexRoute
  UtilitiesTextCounterIndexRoute: typeof UtilitiesTextCounterIndexRoute
  UtilitiesVerticalParallelIndexRoute: typeof UtilitiesVerticalParallelIndexRoute
  AdminBillingAccountIdIndexRoute: typeof AdminBillingAccountIdIndexRoute
  AdminPromptPromptIdIndexRoute: typeof AdminPromptPromptIdIndexRoute
  LegalPrivacyPolicy20230601IndexRoute: typeof LegalPrivacyPolicy20230601IndexRoute
  LegalPrivacyPolicyEnIndexRoute: typeof LegalPrivacyPolicyEnIndexRoute
  LegalTermsOfUseTypeIndexRoute: typeof LegalTermsOfUseTypeIndexRoute
  OrdersOrderIdManageIndexRoute: typeof OrdersOrderIdManageIndexRoute
  OrdersAnonymousOrderIdIndexRoute: typeof OrdersAnonymousOrderIdIndexRoute
  SettingsBillingBillingIdIndexRoute: typeof SettingsBillingBillingIdIndexRoute
  TranslationsGlossaryIdIndexRoute: typeof TranslationsGlossaryIdIndexRoute
  TranslationsJobsJobIdEditorGuideRoute: typeof TranslationsJobsJobIdEditorGuideRoute
  AdminBillingPaymentsPaymentIdIndexRoute: typeof AdminBillingPaymentsPaymentIdIndexRoute
  AdminPromptRubricRubricIdIndexRoute: typeof AdminPromptRubricRubricIdIndexRoute
  AdminUserAccountIdSubscriptionIndexRoute: typeof AdminUserAccountIdSubscriptionIndexRoute
  AdminUserAccountIdUsageIndexRoute: typeof AdminUserAccountIdUsageIndexRoute
  LegalPrivacyPolicy20230601EnIndexRoute: typeof LegalPrivacyPolicy20230601EnIndexRoute
  LegalTermsOfUseEnTypeIndexRoute: typeof LegalTermsOfUseEnTypeIndexRoute
  TranslationsJobsJobIdCompareIndexRoute: typeof TranslationsJobsJobIdCompareIndexRoute
  TranslationsJobsJobIdEditorIndexRoute: typeof TranslationsJobsJobIdEditorIndexRoute
  TranslationsJobsJobIdSmartGlossaryIndexRoute: typeof TranslationsJobsJobIdSmartGlossaryIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PmRouteRoute: PmRouteRouteWithChildren,
  AccountsIndexRoute: AccountsIndexRoute,
  AssistantIndexRoute: AssistantIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  ReviewsIndexRoute: ReviewsIndexRoute,
  SignUpIndexRoute: SignUpIndexRoute,
  SubscriptionIndexRoute: SubscriptionIndexRoute,
  TranslationsIndexRoute: TranslationsIndexRoute,
  TranslatorIndexRoute: TranslatorIndexRoute,
  TranslatorsIndexRoute: TranslatorsIndexRoute,
  UtilitiesIndexRoute: UtilitiesIndexRoute,
  AdminBillingIndexRoute: AdminBillingIndexRoute,
  AdminCouponIndexRoute: AdminCouponIndexRoute,
  AdminFeedbackIndexRoute: AdminFeedbackIndexRoute,
  AdminOrganizationGroupsIndexRoute: AdminOrganizationGroupsIndexRoute,
  AdminPersonalPlanIndexRoute: AdminPersonalPlanIndexRoute,
  AdminPromptIndexRoute: AdminPromptIndexRoute,
  AdminSubscriptionsIndexRoute: AdminSubscriptionsIndexRoute,
  AdminTranslationCatalogIndexRoute: AdminTranslationCatalogIndexRoute,
  AdminTranslationStatisticsIndexRoute: AdminTranslationStatisticsIndexRoute,
  AdminUnitRateIndexRoute: AdminUnitRateIndexRoute,
  AdminUserIndexRoute: AdminUserIndexRoute,
  AssistantConversationIdIndexRoute: AssistantConversationIdIndexRoute,
  AssistantUsageIndexRoute: AssistantUsageIndexRoute,
  LegalPrivacyPolicyIndexRoute: LegalPrivacyPolicyIndexRoute,
  LoginSuccessIndexRoute: LoginSuccessIndexRoute,
  MarketplaceErrorIndexRoute: MarketplaceErrorIndexRoute,
  MarketplaceLandingIndexRoute: MarketplaceLandingIndexRoute,
  OrdersOrderIdIndexRoute: OrdersOrderIdIndexRoute,
  ProjectsNewIndexRoute: ProjectsNewIndexRoute,
  ProjectsRenewalIndexRoute: ProjectsRenewalIndexRoute,
  ReviewsReviewIdIndexRoute: ReviewsReviewIdIndexRoute,
  ReviewsNewIndexRoute: ReviewsNewIndexRoute,
  SettingsAccountIndexRoute: SettingsAccountIndexRoute,
  SettingsBillingIndexRoute: SettingsBillingIndexRoute,
  SettingsHistoryIndexRoute: SettingsHistoryIndexRoute,
  SettingsIntegrationsIndexRoute: SettingsIntegrationsIndexRoute,
  SettingsUsageIndexRoute: SettingsUsageIndexRoute,
  SubscriptionChangeSuccessIndexRoute: SubscriptionChangeSuccessIndexRoute,
  SubscriptionFailIndexRoute: SubscriptionFailIndexRoute,
  SubscriptionProgressIndexRoute: SubscriptionProgressIndexRoute,
  SubscriptionSuccessIndexRoute: SubscriptionSuccessIndexRoute,
  TranslationsAssignedIndexRoute: TranslationsAssignedIndexRoute,
  TranslationsCatIndexRoute: TranslationsCatIndexRoute,
  TranslationsEditorIndexRoute: TranslationsEditorIndexRoute,
  TranslationsGlossaryIndexRoute: TranslationsGlossaryIndexRoute,
  UtilitiesRevisionDiffIndexRoute: UtilitiesRevisionDiffIndexRoute,
  UtilitiesTextCounterIndexRoute: UtilitiesTextCounterIndexRoute,
  UtilitiesVerticalParallelIndexRoute: UtilitiesVerticalParallelIndexRoute,
  AdminBillingAccountIdIndexRoute: AdminBillingAccountIdIndexRoute,
  AdminPromptPromptIdIndexRoute: AdminPromptPromptIdIndexRoute,
  LegalPrivacyPolicy20230601IndexRoute: LegalPrivacyPolicy20230601IndexRoute,
  LegalPrivacyPolicyEnIndexRoute: LegalPrivacyPolicyEnIndexRoute,
  LegalTermsOfUseTypeIndexRoute: LegalTermsOfUseTypeIndexRoute,
  OrdersOrderIdManageIndexRoute: OrdersOrderIdManageIndexRoute,
  OrdersAnonymousOrderIdIndexRoute: OrdersAnonymousOrderIdIndexRoute,
  SettingsBillingBillingIdIndexRoute: SettingsBillingBillingIdIndexRoute,
  TranslationsGlossaryIdIndexRoute: TranslationsGlossaryIdIndexRoute,
  TranslationsJobsJobIdEditorGuideRoute: TranslationsJobsJobIdEditorGuideRoute,
  AdminBillingPaymentsPaymentIdIndexRoute:
    AdminBillingPaymentsPaymentIdIndexRoute,
  AdminPromptRubricRubricIdIndexRoute: AdminPromptRubricRubricIdIndexRoute,
  AdminUserAccountIdSubscriptionIndexRoute:
    AdminUserAccountIdSubscriptionIndexRoute,
  AdminUserAccountIdUsageIndexRoute: AdminUserAccountIdUsageIndexRoute,
  LegalPrivacyPolicy20230601EnIndexRoute:
    LegalPrivacyPolicy20230601EnIndexRoute,
  LegalTermsOfUseEnTypeIndexRoute: LegalTermsOfUseEnTypeIndexRoute,
  TranslationsJobsJobIdCompareIndexRoute:
    TranslationsJobsJobIdCompareIndexRoute,
  TranslationsJobsJobIdEditorIndexRoute: TranslationsJobsJobIdEditorIndexRoute,
  TranslationsJobsJobIdSmartGlossaryIndexRoute:
    TranslationsJobsJobIdSmartGlossaryIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/pm",
        "/accounts/",
        "/assistant/",
        "/clients/",
        "/orders/",
        "/projects/",
        "/reset-password/",
        "/reviews/",
        "/sign-up/",
        "/subscription/",
        "/translations/",
        "/translator/",
        "/translators/",
        "/utilities/",
        "/admin/billing/",
        "/admin/coupon/",
        "/admin/feedback/",
        "/admin/organization-groups/",
        "/admin/personal-plan/",
        "/admin/prompt/",
        "/admin/subscriptions/",
        "/admin/translation-catalog/",
        "/admin/translation-statistics/",
        "/admin/unit-rate/",
        "/admin/user/",
        "/assistant/$conversationId/",
        "/assistant/usage/",
        "/legal/privacy-policy/",
        "/login/success/",
        "/marketplace/error/",
        "/marketplace/landing/",
        "/orders/$orderId/",
        "/projects/new/",
        "/projects/renewal/",
        "/reviews/$reviewId/",
        "/reviews/new/",
        "/settings/account/",
        "/settings/billing/",
        "/settings/history/",
        "/settings/integrations/",
        "/settings/usage/",
        "/subscription/change-success/",
        "/subscription/fail/",
        "/subscription/progress/",
        "/subscription/success/",
        "/translations/assigned/",
        "/translations/cat/",
        "/translations/editor/",
        "/translations/glossary/",
        "/utilities/revision-diff/",
        "/utilities/text-counter/",
        "/utilities/vertical-parallel/",
        "/admin/billing/$accountId/",
        "/admin/prompt/$promptId/",
        "/legal/privacy-policy/2023-06-01/",
        "/legal/privacy-policy/en/",
        "/legal/terms-of-use/$type/",
        "/orders/$orderId/manage/",
        "/orders/anonymous/$orderId/",
        "/settings/billing/$billingId/",
        "/translations/glossary/$id/",
        "/translations/jobs/$jobId/editor/guide",
        "/admin/billing/payments/$paymentId/",
        "/admin/prompt/rubric/$rubricId/",
        "/admin/user/$accountId/subscription/",
        "/admin/user/$accountId/usage/",
        "/legal/privacy-policy/2023-06-01/en/",
        "/legal/terms-of-use/en/$type/",
        "/translations/jobs/$jobId/compare/",
        "/translations/jobs/$jobId/editor/",
        "/translations/jobs/$jobId/smart-glossary/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/pm": {
      "filePath": "pm/route.tsx",
      "children": [
        "/pm/",
        "/pm/projects/$projectId/"
      ]
    },
    "/accounts/": {
      "filePath": "accounts/index.tsx"
    },
    "/assistant/": {
      "filePath": "assistant/index.tsx"
    },
    "/clients/": {
      "filePath": "clients/index.tsx"
    },
    "/orders/": {
      "filePath": "orders/index.tsx"
    },
    "/pm/": {
      "filePath": "pm/index.tsx",
      "parent": "/pm"
    },
    "/projects/": {
      "filePath": "projects/index.tsx"
    },
    "/reset-password/": {
      "filePath": "reset-password/index.tsx"
    },
    "/reviews/": {
      "filePath": "reviews/index.tsx"
    },
    "/sign-up/": {
      "filePath": "sign-up/index.tsx"
    },
    "/subscription/": {
      "filePath": "subscription/index.tsx"
    },
    "/translations/": {
      "filePath": "translations/index.tsx"
    },
    "/translator/": {
      "filePath": "translator/index.tsx"
    },
    "/translators/": {
      "filePath": "translators/index.tsx"
    },
    "/utilities/": {
      "filePath": "utilities/index.tsx"
    },
    "/admin/billing/": {
      "filePath": "admin/billing/index.tsx"
    },
    "/admin/coupon/": {
      "filePath": "admin/coupon/index.tsx"
    },
    "/admin/feedback/": {
      "filePath": "admin/feedback/index.tsx"
    },
    "/admin/organization-groups/": {
      "filePath": "admin/organization-groups/index.tsx"
    },
    "/admin/personal-plan/": {
      "filePath": "admin/personal-plan/index.tsx"
    },
    "/admin/prompt/": {
      "filePath": "admin/prompt/index.tsx"
    },
    "/admin/subscriptions/": {
      "filePath": "admin/subscriptions/index.tsx"
    },
    "/admin/translation-catalog/": {
      "filePath": "admin/translation-catalog/index.tsx"
    },
    "/admin/translation-statistics/": {
      "filePath": "admin/translation-statistics/index.tsx"
    },
    "/admin/unit-rate/": {
      "filePath": "admin/unit-rate/index.tsx"
    },
    "/admin/user/": {
      "filePath": "admin/user/index.tsx"
    },
    "/assistant/$conversationId/": {
      "filePath": "assistant/$conversationId/index.tsx"
    },
    "/assistant/usage/": {
      "filePath": "assistant/usage/index.tsx"
    },
    "/legal/privacy-policy/": {
      "filePath": "legal/privacy-policy/index.tsx"
    },
    "/login/success/": {
      "filePath": "login/success/index.tsx"
    },
    "/marketplace/error/": {
      "filePath": "marketplace/error/index.tsx"
    },
    "/marketplace/landing/": {
      "filePath": "marketplace/landing/index.tsx"
    },
    "/orders/$orderId/": {
      "filePath": "orders/$orderId/index.tsx"
    },
    "/projects/new/": {
      "filePath": "projects/new/index.tsx"
    },
    "/projects/renewal/": {
      "filePath": "projects/renewal/index.tsx"
    },
    "/reviews/$reviewId/": {
      "filePath": "reviews/$reviewId/index.tsx"
    },
    "/reviews/new/": {
      "filePath": "reviews/new/index.tsx"
    },
    "/settings/account/": {
      "filePath": "settings/account/index.tsx"
    },
    "/settings/billing/": {
      "filePath": "settings/billing/index.tsx"
    },
    "/settings/history/": {
      "filePath": "settings/history/index.tsx"
    },
    "/settings/integrations/": {
      "filePath": "settings/integrations/index.tsx"
    },
    "/settings/usage/": {
      "filePath": "settings/usage/index.tsx"
    },
    "/subscription/change-success/": {
      "filePath": "subscription/change-success/index.tsx"
    },
    "/subscription/fail/": {
      "filePath": "subscription/fail/index.tsx"
    },
    "/subscription/progress/": {
      "filePath": "subscription/progress/index.tsx"
    },
    "/subscription/success/": {
      "filePath": "subscription/success/index.tsx"
    },
    "/translations/assigned/": {
      "filePath": "translations/assigned/index.tsx"
    },
    "/translations/cat/": {
      "filePath": "translations/cat/index.tsx"
    },
    "/translations/editor/": {
      "filePath": "translations/editor/index.tsx"
    },
    "/translations/glossary/": {
      "filePath": "translations/glossary/index.tsx"
    },
    "/utilities/revision-diff/": {
      "filePath": "utilities/revision-diff/index.tsx"
    },
    "/utilities/text-counter/": {
      "filePath": "utilities/text-counter/index.tsx"
    },
    "/utilities/vertical-parallel/": {
      "filePath": "utilities/vertical-parallel/index.tsx"
    },
    "/admin/billing/$accountId/": {
      "filePath": "admin/billing/$accountId/index.tsx"
    },
    "/admin/prompt/$promptId/": {
      "filePath": "admin/prompt/$promptId/index.tsx"
    },
    "/legal/privacy-policy/2023-06-01/": {
      "filePath": "legal/privacy-policy/2023-06-01/index.tsx"
    },
    "/legal/privacy-policy/en/": {
      "filePath": "legal/privacy-policy/en/index.tsx"
    },
    "/legal/terms-of-use/$type/": {
      "filePath": "legal/terms-of-use/$type/index.tsx"
    },
    "/orders/$orderId/manage/": {
      "filePath": "orders/$orderId/manage/index.tsx"
    },
    "/orders/anonymous/$orderId/": {
      "filePath": "orders/anonymous/$orderId/index.tsx"
    },
    "/pm/projects/$projectId/": {
      "filePath": "pm/projects/$projectId/index.tsx",
      "parent": "/pm"
    },
    "/settings/billing/$billingId/": {
      "filePath": "settings/billing/$billingId/index.tsx"
    },
    "/translations/glossary/$id/": {
      "filePath": "translations/glossary/$id/index.tsx"
    },
    "/translations/jobs/$jobId/editor/guide": {
      "filePath": "translations/jobs/$jobId/editor/guide.tsx"
    },
    "/admin/billing/payments/$paymentId/": {
      "filePath": "admin/billing/payments/$paymentId/index.tsx"
    },
    "/admin/prompt/rubric/$rubricId/": {
      "filePath": "admin/prompt/rubric/$rubricId/index.tsx"
    },
    "/admin/user/$accountId/subscription/": {
      "filePath": "admin/user/$accountId/subscription/index.tsx"
    },
    "/admin/user/$accountId/usage/": {
      "filePath": "admin/user/$accountId/usage/index.tsx"
    },
    "/legal/privacy-policy/2023-06-01/en/": {
      "filePath": "legal/privacy-policy/2023-06-01/en/index.tsx"
    },
    "/legal/terms-of-use/en/$type/": {
      "filePath": "legal/terms-of-use/en/$type/index.tsx"
    },
    "/translations/jobs/$jobId/compare/": {
      "filePath": "translations/jobs/$jobId/compare/index.tsx"
    },
    "/translations/jobs/$jobId/editor/": {
      "filePath": "translations/jobs/$jobId/editor/index.tsx"
    },
    "/translations/jobs/$jobId/smart-glossary/": {
      "filePath": "translations/jobs/$jobId/smart-glossary/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
